module.exports = __webpack_public_path__ + "static/media/road-trip.7b4e3d3c.png";